import Modal from 'views/components/UI/Modal'
import { H3, H5 } from 'views/components/UI/Text'
import { BackButton, Button } from 'views/components/UI/Buttons'
import { ButtonsContainer, ModalContent, ModalHeader, TrashIconBig, TrashIconWhite } from './styles.styled'
import EnvelopeIconSmall from 'assets/images/envelope-icon-white.png'
import EnvelopeIconBig from 'assets/images/envelope-icon.png'

export interface ModalQuestionsProps {
  showModal: boolean
  handleClose: () => void
  handleSendNotification: () => void
}

const ModalDateChange: React.FC<ModalQuestionsProps> = ({ showModal, handleClose, handleSendNotification }) => {
  const handleSend = () => {
    handleSendNotification()
  }

  return (
    <Modal
      show={showModal}
      setShow={handleClose}
      hideCloseButton
      styleContent={{
        maxWidth: '40vw',
        minWidth: '700px',
        maxHeight: 'auto',
        padding: '20px',
        margin: '0',
      }}
    >
      <ModalContent style={{ alignItems: 'center' }}>
        <ModalHeader style={{ alignItems: 'center', justifyContent: 'center' }}>
          <TrashIconBig src={EnvelopeIconBig} alt="Send Icon" />
          <H3 style={{ textAlign: 'center' }}>¿Deseas enviar una notificación a los evaluadores con la nueva fecha?</H3>
          <H5 style={{ fontWeight: '400', textAlign: 'center' }}>
            Las personas que aún no han contestado, recibirán un correo donde se les informará el cambio de fecha límite
            para responder la evaluación.
          </H5>
        </ModalHeader>
        <ButtonsContainer>
          <BackButton style={{ width: '200px' }} text="Guardar sin notificar" hideIcon onClick={handleClose} />
          <Button
            onClick={handleSend}
            type="button"
            style={{ width: 'fit-content', display: 'flex', alignItems: 'center', gap: '20px' }}
          >
            <TrashIconWhite src={EnvelopeIconSmall} />
            Enviar notificación
          </Button>
        </ButtonsContainer>
      </ModalContent>
    </Modal>
  )
}

export default ModalDateChange
